import React from "react";
import PropTypes from "prop-types";
import { graphql, compose, withApollo } from "react-apollo";
import { updateUser } from "../utilities/auth/graphql/authMutations";
import { getUser } from "../utilities/auth/graphql/authQueries";
import Navbar from "./Navbar";
import EnvBanner from "./EnvBanner";
import Banner from "./Banner";
import Footer from "./Footer";
import ErrorBoundary from "../shared/ErrorBoundary";
import CityInfoBar from "./CityInfoBar";
import { defaultAuthState } from "../utilities/auth/graphql/authDefaultState";
import LanguageProvider from "../utilities/lang/LanguageContext";
import Disclaimer from "./Disclaimer";


const displayNavbar = (hideNavbar) => {
  if (hideNavbar || window.location.pathname === "/mini_search") {
    return null;
  }
  if (window.location.href.indexOf("dashboards.ashevillenc.gov") < 0) {
    return <Navbar />; // / Navbar is SimpliCity
  }
  // CityInfoBar is dashboards
  return <CityInfoBar />;
};

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disclaimerAccepted: false,
    };

    this.handleAcceptDisclaimer = this.handleAcceptDisclaimer.bind(this);
  }

  handleAcceptDisclaimer() {
    localStorage.setItem('disclaimerAccepted', 'true');
    this.setState({ disclaimerAccepted: true });
  }

  componentDidMount() {
    const accepted = localStorage.getItem('disclaimerAccepted');
    if (accepted === 'true') {
      this.setState({ disclaimerAccepted: true });
    }

    const defaultUser = defaultAuthState.user;
    this.props.updateUser({
      variables: {
        loggedIn: defaultUser.loggedIn,
        privilege: defaultUser.privilege,
        name: defaultUser.name,
        email: defaultUser.email,
        provider: defaultUser.provider,
      },
    });
  }

  //


  render() {
    const { disclaimerAccepted } = this.state;

    return (
      <>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/font/bootstrap-icons.min.css"></link>    
      <div
        className={
          this.props.location.query.hideNavbar
            ? "app-parent hidden-navbar"
            : "app-parent"
        }
      >  
        <LanguageProvider>
          <a href="#content" className="skip-nav-link">
            Skip to Main Content
          </a>
          {displayNavbar(this.props.location.query.hideNavbar)}
          <div className="container" id="content">
            <EnvBanner />
            {/* <Banner color="orange" path="*">
              <>
                <p style={{fontWeight: '500', fontSize: '1.25rem', textAlign: 'center' }}>
                  <em>IMPORTANT: Planned Maintenance Outage for All GIS Services</em>
                </p>
                <p style={{textAlign: 'center', fontSize: '1.25rem', }}>Friday, February 28, 7 a.m. – 10 a.m.</p>
              </>
            </Banner> */}
            <ErrorBoundary>{this.props.children}</ErrorBoundary>
          </div>
          {!this.props.location.query.hideNavbar && <Footer />}
          {
            // <AuthProviderModal />
          }
        </LanguageProvider>
        </div>
          {!disclaimerAccepted && (
              <Disclaimer onAccept={this.handleAcceptDisclaimer} />
          )}   
      </>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
  updateUser: PropTypes.func,
};

Main.defaultProps = {
  children: undefined,
  updateUser: undefined,
};

const App = compose(
  graphql(updateUser, { name: "updateUser" }),
  graphql(getUser, {
    props: ({ data: { user } }) => ({
      user,
    }),
  })
)(Main);

export default withApollo(App);